module.exports = __webpack_public_path__ + "media/images/icons/country_flags/in-12c66a162687c5c17ea4541a2faff9c9.svg";